import { formatNumber, formatStorageSize } from "utils/helpers";
import { OverviewInfoCardConfig, OverviewInfoCardVariant } from "./types";

export const SIZE_VARIANT: OverviewInfoCardVariant = "SIZE";
export const OBJECTS_VARIANT: OverviewInfoCardVariant = "OBJECTS";
export const AVERAGE_SIZE_VARIANT: OverviewInfoCardVariant = "AVERAGE_SIZE";

export const OVERVIEW_INFO_CARD_VARIANTS: OverviewInfoCardVariant[] = [
  SIZE_VARIANT,
  OBJECTS_VARIANT,
  AVERAGE_SIZE_VARIANT,
];

export const OverviewInfoCardsConfig: Record<OverviewInfoCardVariant, OverviewInfoCardConfig> = {
  [SIZE_VARIANT]: {
    labelPhrase: "infoCards.sizeLabel",
    tooltipPhrase: "infoCards.sizeHint",
    valueKey: "bucketSize",
    linkTo: "/storage/usage-report",
    icon: "server",
    color: "blue",
    formatter: formatStorageSize,
  },
  [OBJECTS_VARIANT]: {
    labelPhrase: "infoCards.objectsLabel",
    tooltipPhrase: "infoCards.objectsHint",
    valueKey: "objects",
    linkTo: "/storage/overview",
    icon: "server-storage",
    color: "grey",
    formatter: formatNumber,
  },
  [AVERAGE_SIZE_VARIANT]: {
    labelPhrase: "infoCards.averageSizeLabel",
    tooltipPhrase: "infoCards.averageSizeHint",
    valueKey: "averageSize",
    linkTo: "/storage/buckets",
    icon: "statistic",
    color: "purple",
    formatter: formatStorageSize,
  },
};
